import React, { useEffect, useState } from "react";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
// import "./email-log.scss";
import { getValue } from "@utils/lodash";
import MoreAdminSvgComponent from "../../../assets/svg-components/left-menu/more-admin";
import { useNavigate } from "react-router-dom";
import NoAccessPage from "@components/common/NoAccess";
import Loader from "@components/common/Loader";
import Notfound from "@components/Not-Found";
import { QueryRequestHelper } from "@_common/query-request-helper";
import { convertCurrentDate, convertDate } from "@_common/date-helpers";
import {
  downloadEmailLog,
  getEmailLog,
  getTaskDocument,
} from "@services/email-template.service";
import FooterWrapper from "@components/common/FooterWrapper";
import ScrollableDataTable from "@components/ScrollableDatatable/index";
import { tableStatusStyle } from "@_common/colors";
import { EditorState } from "draft-js";
import RightMenuHeaders from "@components/common/RightMenuHeaders";
import { toast } from "react-toastify";
import ReportsNotfoundNoLink from "@components/Page-Not-Found/reports-not-found-nolink";
import ReportsLogsNotfoundNoLink from "@components/Page-Not-Found/reports-logs-not-found";
import MenuRepositorySvgComponent from "../../../assets/svg-components/left-menu/menurepo";
import {
  Card,
  CardBody,
  CardHeader,
  Container,
  Row,
  Col,
  Spinner,
  Badge,
} from "reactstrap";
import { handleDownloadOnClick } from "@_common/downloadfile";
import "./index.scss"

export default function TaskDocument(props: any) {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  const navigate = useNavigate();

  const [templateList, setTemplateList] = useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [typeList, setTypeList] = useState([]);

  /*---------------------------USE Effect----------------------------- */
  useEffect(() => {
    //  const contentState = convertFromRaw(content);

    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getData();
      let dates = params.date ? new Date(params.date) : new Date();
      var from_date = new Date(dates.getFullYear(), dates.getMonth(), 1);
      var to_date = new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
      setFirstDay(from_date);
      setLastDay(to_date);
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getData();

      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.search_text) {
        setSearchInput(params.search_text);
        setShowSearchTextbox(true);
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
      if (params.from_date && params.to_date) {
        // setDate(new Date(params.date));
        var from_date = new Date(params.from_date);
        var to_date = new Date(params.to_date);
        setFirstDay(from_date);
        setLastDay(to_date);
      }
    }
  }, [window.location.href, props.permissionAPITriggered]);

  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = params.date ? new Date(params.date) : new Date();
    var from_date = params.from_date
      ? params.from_date
      : new Date(dates.getFullYear(), dates.getMonth(), 1);
    var to_date = params.to_date
      ? params.to_date
      : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);

    try {
      let payload = {
        page_no: params.page_no ? parseInt(params.page_no) : 1,
        page_size: params.limit ? parseInt(params.limit) : limit,
        search_text: params.search_text,
        from_date: convertDate(from_date),
        to_date: convertDate(to_date),
      };
      let queryRequest = QueryRequestHelper(payload);
      setIsLoading(true);
      let resp = await getTaskDocument(queryRequest);
      if (resp) {
        setTemplateList(
          getValue(resp, `data.tasks`, []).map((item: object) => ({
            ...item,
            created_at: convertCurrentDate(getValue(item, `createdAt`, "")),
          }))
        );

        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(100);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      page_no: page_no,
    };
    let queryRequest = QueryRequestHelper(payload);

    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  /* -------------------------------------------------------------------------- */
  /*                               Search section                               */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    toggleSearch();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search_text) {
      delete params.search_text;
      let payload: any = { ...params };
      // removing null values
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData();
    }
  };

  const handleChangeSearch = async (e: any) => {
    setSearchInput(e.target.value);
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      page_no: 1,
      search_text: e.target.value,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!e.target.value) {
      getData();
    }
  };

  /* ---------------------Column Section------------------------------*/
  const columns = React.useMemo(
    () => [
      {
        Header: "Subject",
        accessor: "subject",
        width: 400,
      },
      {
        Header: "Receipients",
        accessor: "recipients",
        width: 250,
      },
      {
        Header: "Sent on",
        accessor: "created_at",
        width: 150,
      },
      {
        Header: "Status",
        accessor: "status",
        width: 150,
        Cell: ({ value }: { value: boolean }) => {
          // Explicitly type 'value' as boolean
          return value ? "Success" : "Failed";
        },
      },

      //   {
      //     Header: "Action",
      //     width: 140,
      //     Cell: ({ row }: any) => {
      //       return (
      //         <div className="ms-2">
      //           <img
      //             onClick={() =>
      //               // handleViewEntity()
      //               handleViewEntity(getValue(row, `original`, ""))
      //             }
      //             src="/images/view.svg"
      //             className="img-fluid"
      //             style={{ height: "24px", width: "24px" }}
      //           />
      //         </div>
      //       );
      //     },
      //   },
    ],
    []
  );

  const [selectedIDs, setSelectedIDs] = useState<any>([]);
  const getTableState = (value: object) => {
    let selectedIndexList = Object.keys(
      getValue(value, `selectedRowIds`, {})
    ).map((item) => parseInt(item));
    let selectedIds =
      templateList.length > 0
        ? templateList.filter((_item: object, index: number) =>
            selectedIndexList.includes(index)
          )
        : [];
    if (selectedIds.length > 0) {
      setSelectedIDs(
        selectedIds.map((item: object) => getValue(item, `id`, ""))
      );
    } else {
      setSelectedIDs([]);
    }
  };
  const rowClick = (obj: object) => {
    handleViewEntity(getValue(obj, `original`, ""));
  };
  const [check, setCheck] = useState(false);
  const handleRemoveNavItems = () => {
    setCheck(!check);
    setSelectedIDs([]);
  };
  const getTrProps = (rowInfo: any) => {
    if (getValue(rowInfo, `id`, "")) {
      return {
        // style: tableStatusStyle(getValue(rowInfo, `compliance_status`, "")),
      };
    }
    return {};
  };

  const [showUpdatePopup, setShowUpdatePopup] = useState(false);
  const handleViewEntity = async (data: object) => {
    setShowUpdatePopup(true);
    setEditInfo(data);
  };

  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const onEditorStateChange: Function = (editorState: any) => {
    setEditorState(editorState);
  };

  const [editInfo, setEditInfo] = useState({});

  /* -------------------------------------------------------------------------- */
  /*                              Date Routes                                   */
  /* -------------------------------------------------------------------------- */
  const [from_date, setFirstDay] = React.useState(new Date());
  const [to_date, setLastDay] = React.useState(new Date());
  const handleDate = (date: any) => {
    setFirstDay(date[0]);
    setLastDay(date[1]);
  };
  const handleSubmitDate = () => {
    let first: any = convertDate(from_date);
    let last: any = convertDate(to_date);
    if (first && last && first !== "Invalid date" && last !== "Invalid date") {
      let payload: any = {
        from_date: first,
        to_date: last,
      };
      if (payload.from_date && payload.to_date) {
        let queryRequest = QueryRequestHelper(payload);
        navigate(`${window.location.pathname}?${queryRequest}`);
      } else {
        toast.error("Start Date and End Date Required");
      }
    } else {
      toast.error("Please select date");
    }
  };

  const handleExportData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = params.date ? new Date(params.date) : new Date();
    var from_date = params.from_date
      ? params.from_date
      : new Date(dates.getFullYear(), dates.getMonth(), 1);
    var to_date = params.to_date
      ? params.to_date
      : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);

    try {
      let payload = {
        report_type: "EMAIL_LOG_MASTER",
        report_name: `Email Logs - ${convertCurrentDate(
          from_date
        )} to ${convertCurrentDate(to_date)}`,
        from_date: convertDate(from_date),
        to_date: convertDate(to_date),
      };
      let resp = await downloadEmailLog(payload);
      if (resp) {
        navigate(`/self-compliance-logs/EMAIL_LOG_MASTER`);
      }
    } catch (error) {}
  };

  const renderDocumentIcon = (doc: any) => {
    const extension = getValue(doc, `extension`, "");

    if (extension === ".png" || extension === ".jpg" || extension === ".jpeg") {
      return (
        <img
          src="/images/image.svg"
          className="img-fluid cursor-pointer static_image_main"
          style={{ width: "30px", height:"30px" }}
          alt="Image file"
        />
      );
    } else if (extension === ".pdf") {
      return (
        <img
          src="/images/pdf.svg"
          className="img-fluid cursor-pointer static_image"
          style={{ width: "30px" }}
          alt="PDF file"
        />
      );
    } else if (extension === ".xls" || extension === ".xlsx") {
      return (
        <img
          src="/images/excel.svg"
          className="img-fluid cursor-pointer static_image"
          style={{ width: "30px" }}
          alt="Excel file"
        />
      );
    } else {
      return (
        <img
          src="/images/image.svg"
          className="img-fluid cursor-pointer static_image"
          style={{ width: "30px", height:"30px" }}
          alt="Other file"
        />
      );
    }
  };

  // console.log(getValue(props, `subTabPermissionList`, []))

  return (
    <>
      <DashboardLayout
        permissions={getValue(props, `tabPermissionList`, [])}
        subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
      >
        <>
          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <div className="header-parent-icon-holder">
                <MenuRepositorySvgComponent />
              </div>

              <div className="title-wrapper">
                <h6 className="dashbaord-wrapper__header-parent-title">
                  Repository
                </h6>
                <h4 className="dashbaord-wrapper__header-title">
                  Task Documents
                </h4>
              </div>
            </div>

            <div className="d-flex align-items-center">
              <RightMenuHeaders
                licenseStyleCalendar={true}
                //search
                isSearch={true}
                searchInput={search_text}
                showSearchTextbox={showSearchTextbox}
                toggleSearch={toggleSearch}
                toggleSearchClose={toggleSearchClose}
                handleChangeSearch={handleChangeSearch}
                // date range
                dateRange={true}
                from_date={from_date}
                to_date={to_date}
                handleDate={handleDate}
                handleSubmitDate={handleSubmitDate}
                //Line Seperator of button
                lineSeperator={true}
              />
              {/* <div className="floatable-search-container">
                <div
                  className="cursor-pointer searchbutton"
                  onClick={() => handleExportData()}
                >
                  <img
                    src="/images/download-gray.svg"
                    className="img-fluid add-filter-wrapper__upload-image"
                  />
                </div>
              </div> */}
            </div>
          </div>

          {!isLoading &&
          !getValue(props, `subTabPermissionList`, []).includes(
            "repository_task_library"
          ) ? (
            <NoAccessPage />
          ) : (
            <section>
              {isLoading || !props.permissionAPITriggered ? (
                <Loader />
              ) : getValue(templateList, `length`, 0) > 0 ? (
                <>
                  <div className={`main-page-layout-wrapper`} style={{minHeight: "calc(100vh - 171px)"}}>
                    <div className="document-box-container mb-20">
                      {/* {templateList.map((doc: any) => (
                        <div key={doc.task_id} className="document-box">
                          <Card
                            className="border cursor-pointer"
                            onClick={() =>
                              handleDownloadOnClick(
                                getValue(doc, `url`, ""),
                                getValue(doc, `name`, "")
                              )
                            }
                          >
                            <CardBody className="p-0">
                                <div className="d-flex align-content-center margin">
                                    <div className="document-icon-container text-center py-3" style={{width: "20px"}}>
                                        {renderDocumentIcon(doc)}
                                    </div>

                                    <div style={{marginLeft: "16px"}}>
                                        <h4>{doc.task_id}</h4>
                                        <p>{doc.name}{doc.extension}</p>
                                    </div>
                                </div>
                            </CardBody>
                          </Card>
                        </div>
                      ))} */}

                        {templateList.map((doc: any) => (
                        <div key={doc.task_id} className="document-box">
                            <Card
                            className="border cursor-pointer document-card"
                            onClick={() =>
                                handleDownloadOnClick(
                                getValue(doc, `url`, ""),
                                getValue(doc, `name`, "")
                                )
                            }
                            >
                            <CardBody className="d-flex align-items-start">
                                {/* Document Icon */}
                                <div className="document-icon-container">
                                {renderDocumentIcon(doc)}
                                </div>

                                {/* Task ID and Name */}
                                <div className="document-text-container">
                                <h4 className="task-id">{doc.task_id}</h4>
                                <p className="document-name">
                                    <span className="name">{doc.name}</span>
                                    <span className="extension">.{doc.extension}</span>
                                </p>
                                </div>
                            </CardBody>
                            </Card>
                        </div>
                        ))}

                    </div>
                  </div>

                  <FooterWrapper
                    list={templateList}
                    totalCount={totalCount}
                    limit={limit}
                    page_no={page_no}
                    handleChangePagination={handleChangePagination}
                    handleChangeLimit={handleChangeLimit}
                  />
                </>
              ) : (
                <>
                  <div className={`main-page-layout-wrapper`}>
                    {Object.keys(params).length !== 0 ? (
                      <ReportsLogsNotfoundNoLink />
                    ) : (
                      <ReportsLogsNotfoundNoLink />
                    )}
                  </div>
                </>
              )}
            </section>
          )}
        </>
      </DashboardLayout>
    </>
  );
}
